import decentralise from "../assets/images/decentrlise.svg";
import foolProof from "../assets/images/foolProof.svg";
import privacyFirst from "../assets/images/privacyFirst.svg";
import easyToUse from "../assets/images/easyToUse.svg";
import affordable from "../assets/images/affordable.svg";
import verification from "../assets/images/verification.svg";

export const featureCardContent = [
  // 'Documents are generated as PDFs by Issuers',
  // 'Unique fingerprint for each PDF is computed by LegitDoc software',
  // 'All PDF fingerprints are condensed into a single fingerprint',
  // 'The single fingerprint is uploaded on Ethereum Blockchain against Issuer’s public key',
  // 'A unique blockchain- based Proof File is generated for each PDF',
  // 'Original PDF document + Corresponding Proof File = LegitDoc zip files',
  // 'LegitDoc zip files are issued to respective document owners; these files can now be shared with Verifiers',
  // 'Verifiers upload LegitDoc zip files on the LegitDoc Verification Portal',
  // 'Verification Portal compares LegitDoc zip file data with the data on the blockchain',
  // 'Verifiers are notified of authenticity of document',
  "Issuer issues document and generated proof which serves as proof of document as well as proof of origin of the document",
  "Issuer stores proof and metadata on blockchain and publishes the original document",
  "Users are allowed to store documents as files or as credentials",
  "Documents can be uploaded on doctrust to verify it's existence as well as source of origin",
  "DocTrust compares uploaded file data with the data on the blockchain",
  "Users are notified of authenticity of document",
];

export const featureContent = [
  {
    image: decentralise,
    title: "Blockchain secured",
    desc: "Based on blockchain technology which ensures high degree of confidentiality and security",
  },
  {
    image: foolProof,
    title: "Tamper-Proof",
    desc: "Proof of existence blockchain to ensure document is legial",
  },
  {
    image: affordable,
    title: "Time & Cost efficient",
    desc: "Doctrust saves 90% time and money over manual processes",
  },
  {
    image: verification,
    title: "Quick verification",
    desc: "Verify your digital documents via drag and drop instantly",
  },
  {
    image: privacyFirst,
    title: "Control of privacy",
    desc: "An unparalleled privacy solution, as no one can access your documents except the document holder provides full control of your privacy.",
  },
  {
    image: easyToUse,
    title: "Customizable",
    desc: "Generic modular solution which can be implemented with different blockchains case to case",
  },
];
